import type { RouteRecordRaw } from 'vue-router';

export const INVENTORY_WAREHOUSE_ROUTER: RouteRecordRaw[] = [
  {
    path: '/inventory/warehouse',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/inventory/warehouse/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/inventory/warehouse/views/List.vue'),
        name: 'Inventory Warehouse List',
        meta: {
          title: '창고별 재고조회',
        },
      },
    ],
  },
];
